import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, UserRoles, DataListModel, IKeyValueInterface, Permission, PermissionType, Entity, WeGoAuthorizedLink } from '../../shared/config';
import { AdminOfSharedVehicleGroupService } from '../models/admin-of-SharedVehicleGroup.service';
import { AdminOfSharedVehicleGroupModel } from '../models/admin-of-SharedVehicleGroup.model';
import { RoleAvailabilityModel } from '../../roleavailability/models/roleavailability.model';
import { retry } from 'rxjs/operator/retry';
import { PersonService } from '../../person/models/person.service';
import { SharedVehicleGroupService } from '../../sharedvehiclegroup/models/sharedvehiclegroup.service';
import { SharedVehicleGroupAdminInvitationModel } from '../../admin-invite-popup/models/admin-to-invite.model';


@Component({
  selector: 'wego-admin-of-sharedVehicleGroup',
  template: require('../views/admin-of-sharedvehiclegroup-list.component.html'),
  providers: [AdminOfSharedVehicleGroupService, PersonService, SharedVehicleGroupService],

})
export class AdminOfsharedVehicleGroupListComponent implements OnInit {
  addSvgAdminLink: WeGoAuthorizedLink;
  inviteTitle: any;
  ToggleRoleName: string;
  ToggleUserName: string;
  ToggleAddRole: boolean;
  ToggleRoleHashId: string;
  ToggleRolePersonHashID: string;
  roleAvailabilityList: RoleAvailabilityModel[];
  DataListModel: DataListModel;
  sub: any;
  svgHashId: string;
  sharedVehicleGroupAdminList: AdminOfSharedVehicleGroupModel[];
  errorModel: IKeyValueInterface[];
  roleColumns: number = 0;
  apiErrorMsg: string;
  isLoading: boolean;
  deletePersonMasterHashId: string;
  resetPasswordPersonHashId: string;
  message: string;
  errorMessage: string;
  sharedVehicleGroupName: string;
  urlDefaultPage: string;
  urlSharedVehicleGroupList: string;
  isParentCheck: boolean;
  isMultipleDelete: boolean;
  deleteMessage: string;
  validateMessage: string;
  private popupMsg: string;
  private popupTitle: string;
  private module: string;
  private breadCrumbList: string;
  private sharedVehicleGroupList: string;
  toggleRoleMsg: string;
  toggleRoleTitle: string;


  @ViewChild('alertModal') public alertModal: any;
  @ViewChild('resetPasswordModal') public resetPasswordModal: any;
  @ViewChild('inActiveModal') public inActiveModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('toggleRolePopup') public toggleRolePopup: any;
  @ViewChild('inviteAdminModal') public inviteAdminModal: any;


  constructor(private adminOfsharedVehicleGroupService: AdminOfSharedVehicleGroupService,
    private personService: PersonService,
    private sharedVehicleGroupService: SharedVehicleGroupService,
    private activeRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService) {
  }

  get isAnyChecked(): boolean {
    if (this.sharedVehicleGroupAdminList) {
      let isCheck = this.sharedVehicleGroupAdminList.some(x => x.isChecked == true);
      if (isCheck) {
        if (this.sharedVehicleGroupAdminList.every(x => x.isChecked == true))
          this.isParentCheck = true;
        else
          this.isParentCheck = false;
      }
      else {
        this.isParentCheck = false;
      }

      return isCheck;
    }
    else {
      this.isParentCheck = false;
      return false;
    }
  }

  get isDeleteAccess(): boolean {
    if (this.sharedVehicleGroupAdminList) {
      return this.sharedVehicleGroupAdminList.some(x => x.isDeletable);
    }
    else { return false; }
  }

  ngOnInit() {
    this.module = this.translate.instant('LblSharedVehicleGroupAdmin');
    this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
    this.sharedVehicleGroupList = this.translate.instant('LblListPage', [this.translate.instant('LblSharedVehicleGroup')]);
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    this.DataListModel.searchField = ["userName", "firstName", "lastName"];
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
    this.urlSharedVehicleGroupList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.inviteTitle = this.translate.instant('LblInvite') + " " + this.translate.instant('LblSharedVehicleGroupAdmin');

    this.sub = this.activeRoute
      .params
      .subscribe(params => {
        this.svgHashId = params['id'] || '';
        if (this.svgHashId != '') {
          this.addSvgAdminLink = new WeGoAuthorizedLink("",
            Permission.PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW, PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblInvite', Entity.SVG, this.svgHashId);

          this.GetSharedVehicleGroupDetails();
        }
      });
  }

  public RoleAvailabilityList() {
    this.isLoading = true;
    if (this.svgHashId) {
      this.adminOfsharedVehicleGroupService.GetAllRoleAvailability(new DataListModel(), this.svgHashId)
        .subscribe(
        res => {
          this.roleAvailabilityList = res.data;
          this.roleColumns = this.roleAvailabilityList.length;
          this.GetAdminOfsharedVehicleGroupList();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
    }
  }

  public GetSharedVehicleGroupDetails() {
    if (this.svgHashId) {
      this.isLoading = true;
      this.sharedVehicleGroupService.GetSharedVehicleGroupBasicDetail(this.svgHashId)
        .subscribe(
        res => {
          if (res.data) {
            this.sharedVehicleGroupName = res.data.entityName;
            this.RoleAvailabilityList();
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        });
    }
  }

  public GetAdminOfsharedVehicleGroupList() {
    this.isLoading = true;
    this.adminOfsharedVehicleGroupService.GetAdminOfSharedVehicleGroupList(this.svgHashId, this.DataListModel)
      .subscribe(
      res => {
        this.sharedVehicleGroupAdminList = res.data;
        this.DataListModel.totalItems = res.totalRecords;
        this.DataListModel.infoMessage = res.error;
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.sharedVehicleGroupAdminList = [];
        this.DataListModel.infoMessage = error;
        this.isLoading = false;
      });
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetAdminOfsharedVehicleGroupList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
    this.GetAdminOfsharedVehicleGroupList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetAdminOfsharedVehicleGroupList();
  };

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetAdminOfsharedVehicleGroupList();
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.adminOfsharedVehicleGroupService.ExportAdminOfsharedVehicleGroupList(this.svgHashId, this.DataListModel)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "SharedVehicleGroupAdmin" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });;
  }

  public DeleteAdminOfSharedVehicleGroup(deleteAdminOfsvgList: string[]) {
    this.isLoading = true;
    this.adminOfsharedVehicleGroupService.DeleteAdminOfSharedVehicleGroup(this.svgHashId, deleteAdminOfsvgList)
      .subscribe(
      res => {
        this.DataListModel.currentPage = 1;
        this.GetAdminOfsharedVehicleGroupList();
        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
        this.ShowSuccessPopup();
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnParentCheck(isChecked: boolean) {
    this.sharedVehicleGroupAdminList.filter(x => x.isDeletable).forEach(x => x.isChecked = isChecked);
  }

  public ShowAlertModal(deletePersonMasterHashId?: string): void {
    if (deletePersonMasterHashId) {
      this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
      this.isMultipleDelete = false;
      this.deletePersonMasterHashId = deletePersonMasterHashId;
    }
    else {
      this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
      this.isMultipleDelete = true;

    }
    this.alertModal.show();
  }

  public HideAlertModal(): void {
    this.deletePersonMasterHashId = "";
    this.alertModal.hide();
  }

  public SuccessAlertModalClick(): void {
    let deleteAdminOfSVGList: any[];
    if (this.isMultipleDelete)
      deleteAdminOfSVGList = this.sharedVehicleGroupAdminList.filter(x => x.isChecked).map(x => x.personMasterHashId);
    else
      deleteAdminOfSVGList.push(this.deletePersonMasterHashId);

    this.DeleteAdminOfSharedVehicleGroup(deleteAdminOfSVGList);
    this.alertModal.hide();
  }

  // Add SharedVehicleGroup admin popup
  public ShowAddAdminOfSharedVehicleGroupModal() {
    this.ShowInviteAdminModal();
  }

  public ToggleRoleAvailability(personHashID: string, roleHashId: string, personRolesHashIds: string[], roleName: string, userName: string) {
    this.ToggleRolePersonHashID = personHashID;
    this.ToggleRoleHashId = roleHashId;
    this.ToggleUserName = userName;
    this.ToggleRoleName = roleName;

    if (this.CheckRole(personRolesHashIds, roleHashId)) {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [userName, roleName]);
      this.ToggleAddRole = false;
      this.ShowToggleRolePopup();
    } else {
      this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [userName, roleName]);
      this.ToggleAddRole = true;
      this.ShowToggleRolePopup();
    }
  }

  public ShowToggleRolePopup(): void {
    this.toggleRolePopup.show();
  }

  public HideToggleRolePopup(): void {
    this.ToggleRolePersonHashID = '';
    this.ToggleRoleHashId = '';
    this.ToggleUserName = '';
    this.ToggleRoleName = '';

    this.toggleRolePopup.hide();

  }
  public ConfirmToggleRolePopup(): void {
    if (this.ToggleAddRole) {
      this.adminOfsharedVehicleGroupService.AddAdminOfSharedVehicleGroupRole(this.svgHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
        .subscribe(
        res => {
          this.GetAdminOfsharedVehicleGroupList();
          this.popupMsg = this.translate.instant('LblRoleAddedSuccess', [this.ToggleUserName, this.ToggleRoleName]);
          this.HideToggleRolePopup();
          this.ShowSuccessPopup();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
          this.HideToggleRolePopup();
        });
    } else {

      this.adminOfsharedVehicleGroupService.DeleteAdminOfSharedVehicleGroupRole(this.svgHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
        .subscribe(
        res => {
          this.GetAdminOfsharedVehicleGroupList();
          this.popupMsg = this.translate.instant('LblRoleDeletedSuccess', [this.ToggleUserName, this.ToggleRoleName]);
          this.HideToggleRolePopup();
          this.ShowSuccessPopup();
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
          this.HideToggleRolePopup();
        });
    }
  }

  //Reset company admin password
  public ResetPersonPassword(personHashID: string) {
    this.personService.ResetPersonPassword(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResetPasswordSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResetPasswordFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowResetPasswordModal(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
    this.resetPasswordModal.show();
  }

  public HideResetPasswordModal(): void {
    this.resetPasswordPersonHashId = "";
    this.resetPasswordModal.hide();
  }
  public SuccessResetPasswordModalClick(): void {
    this.resetPasswordModal.hide();
    this.ResetPersonPassword(this.resetPasswordPersonHashId);
  }

  public ResendActivationMail(personHashID: string): void {
    this.resetPasswordPersonHashId = personHashID;
    this.personService.ReSendActivationMail(personHashID)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblResendActivationMailSuccess');
          this.ShowSuccessPopup();
        }
        else {
          this.popupMsg = this.translate.instant('LblResendActivationMailFailure');
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();

  }
  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.toggleRolePopup.hide();
  }

  public ShowInviteAdminModal(): void {
    this.inviteAdminModal.availableRoles = JSON.parse(JSON.stringify(this.roleAvailabilityList));
    this.inviteAdminModal.availablePersons = '';
    this.inviteAdminModal.show();
  }

  public HideInviteAdminModal(): void {
    this.inviteAdminModal.hide();
  }

  public SuccessInviteAdminModalClick($event: any): void {
    console.log($event);

    let adminInvitation = new SharedVehicleGroupAdminInvitationModel();
    adminInvitation.emailAddress = $event.emailAddress;
    adminInvitation.personHashId = $event.personHashId;
    adminInvitation.roleHashIdList = $event.roleHashIdList;
    adminInvitation.sharedVehicleGroupHashId = this.svgHashId;

    this.adminOfsharedVehicleGroupService.InviteAdminOfsharedVehicleGroup(adminInvitation)
      .subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant('LblInvitationMailSuccess');
          this.HideInviteAdminModal();
          this.ShowSuccessPopup();
        }
        else {
          this.inviteAdminModal.errorModel = res.error;
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
        this.HideInviteAdminModal();
      });
  }

  public SearchEmailAddress($event: any): void {
    let emailAddress = $event.emailAddress;
    this.isLoading = true;
    this.adminOfsharedVehicleGroupService.GetPersonListToInvite(this.svgHashId, emailAddress)
      .subscribe(
      res => {
        if (res.data) {
          this.inviteAdminModal.availablePersons = res.data;
          this.inviteAdminModal.errorModel = [];
        } else {
          this.inviteAdminModal.errorModel = res.error;
        }
        this.isLoading = false;
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public CheckRole(existingArray: string[], currentRole: string) {
    return existingArray.some(x => x == currentRole);
  }
  
  get isResetCookieAccess(): boolean {
    if (this.sharedVehicleGroupAdminList) {
      return this.sharedVehicleGroupAdminList.some(x => !x.twoFaDisabled);
    } else {
      return false;
    }
  }

  get isTwoFaResetKeyAccess(): boolean {
    if (this.sharedVehicleGroupAdminList) {
      return this.sharedVehicleGroupAdminList.some(x => x.resetKeyEnabled);
    } else {
      return false;
    }
  }

  public ResetPersonCookies(personHashID: string) {
    ;
    this.personService.ResetTwoFaCookie(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblCookieResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblCookieResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  public ResetPersonTwoFA(personHashID: string) {

    this.personService.ResetTwoFaKey(personHashID).subscribe(
      res => {
        if (res.data) {
          this.popupMsg = this.translate.instant(
            'LblKeyResetSuccess'
          );
          this.ShowSuccessPopup();
        } else {
          this.popupMsg = this.translate.instant(
            'LblKeyResetFailed'
          );
          this.popupTitle = this.translate.instant('LblWarning');
          this.ShowSuccessPopup();
        }
      },
      error => {
        this.errorMessage = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin-of-sharedvehiclegroup/components/admin-of-sharedvehiclegroup-list.component.ts